import type { SuperAgentRequest } from 'superagent';

export const CSRF_COOKIE_NAME = 'XSRF-TOKEN';
export const CSRF_HEADER_NAME = 'X-XSRF-TOKEN';

const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS', 'TRACE']);

export const getCsrfToken = (): string | undefined => {
  const prefix = `${CSRF_COOKIE_NAME}=`;
  const cookie = document.cookie
    .split(';')
    .map(value => value.trim())
    .find(value => value.startsWith(prefix));
  return cookie ? decodeURIComponent(cookie.substring(prefix.length)) : undefined;
};

const needsCsrfToken = (method: string | undefined, url: string | undefined): boolean => {
  if (SAFE_METHODS.has((method || 'GET').toUpperCase())) return false;
  if (!url) return true;
  return new URL(url, window.location.href).origin === window.location.origin;
};

export const applyCsrfToSuperagent = (request: SuperAgentRequest): void => {
  if (!needsCsrfToken(request.method, request.url)) return;
  const token = getCsrfToken();
  if (token) request.set(CSRF_HEADER_NAME, token);
};

export const configureJQueryCsrf = (): void => {
  window.$?.ajaxPrefilter?.((options: any, _originalOptions: any, xhr: any) => {
    if (!needsCsrfToken(options.type || options.method, options.url)) return;
    const token = getCsrfToken();
    if (token) xhr.setRequestHeader(CSRF_HEADER_NAME, token);
  });
};

export const csrfFetch: typeof fetch = (input, init) => {
  const request = input instanceof Request ? input : undefined;
  const method = init?.method || request?.method || 'GET';
  const url = request?.url || String(input);
  if (!needsCsrfToken(method, url)) return fetch(input, init);

  const headers = new Headers(request?.headers);
  new Headers(init?.headers).forEach((value, name) => headers.set(name, value));
  const token = getCsrfToken();
  if (token) headers.set(CSRF_HEADER_NAME, token);
  return fetch(input, {...init, headers});
};
